export const OCP_ID = "ocpId";
export const COMMUNITY = "communityId";

// Step 1
export const PROPERTY_ID = "propertyId";
export const OWNER = "primaryUserName";
export const OWNER_ID = "primaryUserId";
export const RECEIPT_DATE = "receiptDate";
export const RECEIPT_FROM = "receiptFrom";
export const REPORTER_NAME = "reporterName";
export const REPORTER_TITLE = "reporterTitle";
export const REPORTER_EMAIL = "reporterEmail";
export const REPORTER_PHONE = "reporterPhone";
export const SELLER_NAME = "sellerName";
export const SELLER_EMAIL = "sellerEmail";
export const SELLER_PHONE = "sellerPhone";
export const TARGET_CLOSING_DATE = "targetClosingDate";
export const PAL_NEEDED_BY_DATE = "palNeededByDate";
export const CLOSING_CONTACT_SOURCE = "closingContactSource";
export const CLOSING_CONTACT_NAME = "closingContactName";
export const CLOSING_CONTACT_EMAIL = "closingContactEmail";
export const CLOSING_CONTACT_PHONE = "closingContactPhone";
export const REPORTER_CONTACT = "REPORTER";
export const DIFFERENT_PERSON_CONTACT = "DIFFERENT_PERSON";

// Step 2
export const FEES = "packetFees";
export const CLOSING_FEE = "closingFee";
export const CLOSING_FEE_AMT = "closingFeeAmt";
export const RUSH_FEE = "rushFee";
export const MOVE_IN_FEE = "movingFee";
export const CAPITAL_CONTRIBUTION = "capitalContribution";

export const FEE_TYPE_ID = "feeTypeId";
export const FEE_NAME = "feeName";
export const IS_SELECTED = "selected";
export const FEE_AMOUNT = "feeAmount";
export const RECEIPTS = "receipts";
export const RECEIPT_TEMP_ID = "receiptTempId";
export const RECEIPT_ID = "receiptId";
export const DEFAULT_AMOUNT = "defaultAmount";
export const CHEQUE_NO = "chequeNumber";
export const RECEIVED_DATE = "receivedDate";
export const AMOUNT_RECEIVED = "amountReceived";
export const RECEIPT_PROOF = "receiptProof";
export const ACK = "receiptStatus";
export const ACKNOWLEDGED = "ACKNOWLEDGED";
export const ACK_AT = "acknowledgedAt";
export const ACK_BY = "acknowledgedByUserName";

// step 3
export const ACTUAL_CLOSING_DATE = "actualClosingDate";
export const CLOSING_PROOF_DOCS = "closingProofDocs";
export const OWNERSHIP_PROOF_DOCS = "ownershipProofDocs";
export const PROOF_DOCS = "proofDocs";
export const PROOF_TYPE = "documentTypeId";
export const IS_REQUIRED = "isRequired";
export const FILE_SIZE = "maxFileSizeMb";
export const FILE_TYPE = "allowedExtensions";
export const PROOF_FILE = "file";
export const UPLOADED_STATUS = "uploaded";
export const ATTACHMENT_ID = "attachmentId";
export const PACKET_DOC_ID = "packageDocumentId";

export const CC_EMAIL = "ccEmails";
export const DELIVERY_METHOD = "deliveryMethod";
export const EMAIL_SUBJECT = "emailSubject";
export const EMAIL_MESSAGE = "emailMessage";
export const CLOSING_ACK = "closingPackageAcknowledged";

// step 4
export const OWNERSHIP_LIST = "propertyUserAssociations";
export const NEW_OWNERSHIP_ID = "newOwnershipId";
export const PREVIOUS_OWNERSHIP_ID = "previousOwnershipId";

export const OWNERSHIP_TYPE = "ownershipType";
export const ENTITY_NAME = "entityName";
export const OWNER_SHARE_VALID = "ownerShareValid";
export const ENTITY_NAME_PRESENCE_VALID = "entityNamePresenceValid";
export const OWNER_PRESENT = "ownerPresent";
export const OWNER_COUNT_VALID = "ownerCountValid";
export const CLOSING_CONTACT_VALID = "closingContactValid";

export const STATUS = "stage";

export const receivedFromOptions = [
  { label: "Seller", value: "seller" },
  { label: "Buyer", value: "buyer" },
  { label: "Buyer Agent", value: "buyer_agent" },
  { label: "Buyer Attorney", value: "buyer_attorney" },
  { label: "Other", value: "other" },
];

export const steps = [
  { id: 1, label: "Intake", status: "INTAKE" },
  { id: 2, label: "Fees", status: "FEES_CAPTURED" },
  { id: 3, label: "Package", status: "COMPLETED" },
  { id: 4, label: "Ownership Change", status: "OWNERSHIP_CHANGE_DOC" },
  { id: 5, label: "Onboarding", status: "OWNER_ONBOARDED" },
  { id: 6, label: "Audit" },
];

export const proofTypeOptions = [
  { label: "Ocp Pal Minutes", value: "OCP_PAL_MINUTES", type: "closingProof" },
  { label: "Ocp Budget", value: "OCP_BUDGET", type: "closingProof" },
  { label: "Ocp Reserve Study", value: "OCP_RESERVE_STUDY", type: "closingProof" },
  { label: "Ocp Insurance", value: "OCP_INSURANCE", type: "closingProof" },
  { label: "Ocp Onboarding", value: "OCP_ONBOARDING", type: "closingProof" },
  { label: "Ocp Other", value: "OCP_OTHER", type: "both" },
  { label: "Ocp Owner Deed", value: "OCP_OWNER_DEED", type: "userProof" },
  { label: "Ocp Owner Application", value: "OCP_OWNER_APPLICATION", type: "userProof" },
  { label: "Ocp Owner Rule Acknowledgement", value: "OCP_OWNER_RULE_ACKNOWLEDGEMENT", type: "userProof" },
  { label: "Ocp Owner Form", value: "OCP_OWNER_FORM", type: "userProof" },
  { label: "Ocp Owner Insurance", value: "OCP_OWNER_INSURANCE", type: "userProof" },
];

export const STEP_FIELDS = {
  0: [
    PROPERTY_ID,
    RECEIPT_DATE,
    RECEIPT_FROM,
    REPORTER_NAME,
    REPORTER_TITLE,
    REPORTER_EMAIL,
    REPORTER_PHONE,
    SELLER_NAME,
    SELLER_EMAIL,
    SELLER_PHONE,
    TARGET_CLOSING_DATE,
    PAL_NEEDED_BY_DATE,
    CLOSING_CONTACT_SOURCE,
    CLOSING_CONTACT_NAME,
    CLOSING_CONTACT_EMAIL,
    CLOSING_CONTACT_PHONE,
    REPORTER_CONTACT,
    DIFFERENT_PERSON_CONTACT
  ], // Step 1
  1: [CLOSING_FEE, RUSH_FEE, MOVE_IN_FEE, CAPITAL_CONTRIBUTION], // Step 2
  2: [ACTUAL_CLOSING_DATE, PROOF_DOCS],                                          // Step 3
};

export const revisionType = {
  ADD: "Add",
  MOD: "Modification"
} as const

export const ATTACHMENTS = "ATTACHMENTS";
export const DOWNLOAD_LINK = "DOWNLOAD_LINK";

export const uploadStatusStyle = {
  pending: "bg-amber-50 border-amber-600 border text-amber-600",
  uploaded: "bg-green-50 border-green-600 border text-green-600"
}